var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 100.000000 100.000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144 851 c-58 -35 -66 -77 -62 -327 3 -243 6 -255 71 -294 28 -18 51 -20 187 -20 l155 0 17 30 17 30 -160 0 c-155 0 -193 6 -211 34 -8 11 -11 336 -4 336 2 0 78 -40 169 -90 91 -49 170 -90 177 -90 6 0 86 40 178 90 l167 90 3 -50 c3 -41 6 -50 22 -50 10 0 25 -3 34 -6 26 -10 23 206 -3 263 -33 72 -37 73 -403 73 -300 0 -325 -1 -354 -19z m686 -61 c11 -11 20 -33 20 -48 0 -26 -13 -35 -170 -120 -93 -51 -174 -92 -179 -92 -5 0 -86 41 -180 92 -158 85 -171 94 -171 120 0 15 9 37 20 48 19 19 33 20 330 20 297 0 311 -1 330 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683 358 c-143 -143 -143 -143 -164 -217 -18 -64 -19 -75 -6 -88 13 -13 23 -12 88 7 73 21 75 23 211 159 82 82 139 147 143 164 15 58 -36 117 -101 117 -22 0 -57 -29 -171 -142z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageEdit);
export default __webpack_public_path__ + "static/media/messageEdit.83454495501fa46197729e76e4b1a146.svg";
export { ForwardRef as ReactComponent };